/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicProgramStatusUpdateRecipientPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StrategicProgramStatusUpdateRecipientPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicProgramStatusUpdateReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicProgramStatusUpdateRecipientPaginationSlice);
  }
}(this, function(ApiClient, StrategicProgramStatusUpdateRecipientPaginationSlice) {
  'use strict';




  /**
   * The StrategicProgramStatusUpdateReport model module.
   * @module model/StrategicProgramStatusUpdateReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategicProgramStatusUpdateReport</code>.
   * @alias module:model/StrategicProgramStatusUpdateReport
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>StrategicProgramStatusUpdateReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategicProgramStatusUpdateReport} obj Optional instance to populate.
   * @return {module:model/StrategicProgramStatusUpdateReport} The populated <code>StrategicProgramStatusUpdateReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('NotificationRecipients')) {
        obj['NotificationRecipients'] = StrategicProgramStatusUpdateRecipientPaginationSlice.constructFromObject(data['NotificationRecipients']);
      }
      if (data.hasOwnProperty('CanUserEditStatusUpdate')) {
        obj['CanUserEditStatusUpdate'] = ApiClient.convertToType(data['CanUserEditStatusUpdate'], 'Boolean');
      }
      if (data.hasOwnProperty('ProgramID')) {
        obj['ProgramID'] = ApiClient.convertToType(data['ProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('UpdateDate')) {
        obj['UpdateDate'] = ApiClient.convertToType(data['UpdateDate'], 'Date');
      }
      if (data.hasOwnProperty('RiskLevelID')) {
        obj['RiskLevelID'] = ApiClient.convertToType(data['RiskLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('NewValue')) {
        obj['NewValue'] = ApiClient.convertToType(data['NewValue'], 'Number');
      }
      if (data.hasOwnProperty('Comment')) {
        obj['Comment'] = ApiClient.convertToType(data['Comment'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/StrategicProgramStatusUpdateRecipientPaginationSlice} NotificationRecipients
   */
  exports.prototype['NotificationRecipients'] = undefined;
  /**
   * @member {Boolean} CanUserEditStatusUpdate
   * @default false
   */
  exports.prototype['CanUserEditStatusUpdate'] = false;
  /**
   * @member {Integer} ProgramID
   * @default 0
   */
  exports.prototype['ProgramID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Date} UpdateDate
   */
  exports.prototype['UpdateDate'] = undefined;
  /**
   * @member {Integer} RiskLevelID
   * @default 0
   */
  exports.prototype['RiskLevelID'] = 0;
  /**
   * @member {Number} NewValue
   * @default 0.0
   */
  exports.prototype['NewValue'] = 0.0;
  /**
   * @member {String} Comment
   * @default ''
   */
  exports.prototype['Comment'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


